import showNotify from './showNotify';
import showError from './showError';
import hide from './hide';

export default {
  showNotify,
  showError,
  hide,
};
